<template>
	<section class="why-choose-us">
		<div class="why-choose-us__inner _cnt">
			<div class="why-choose-us__title _h1">
				{{ $t('Why Choose SkinSmoke?') }}
			</div>
			<div class="why-choose-us__line _line"><span></span></div>
			<div class="why-choose-us__items">
				<div class="why-choose-us__item">
					<div class="why-choose-us__large why-choose-us__large_first">
						<div class="why-choose-us__large-content">
							<div class="why-choose-us__subtitle _md">
								{{ $t('Extensive Selection') }}
							</div>
							<div class="why-choose-us__text _text-primary">
								{{
									$t(
										'Dive into a massive catalog of CS2 skins — from knives and gloves to rifles, stickers, and cases.'
									)
								}}
							</div>
						</div>
						<div class="why-choose-us__bg _ibg">
							<img src="@/assets/img/bg/why/01.png" />
						</div>
					</div>
					<div class="why-choose-us__small">
						<div class="why-choose-us__small-content">
							<div class="why-choose-us__subtitle _md">
								{{ $t('Competitive Prices') }}
							</div>
							<div class="why-choose-us__text _text-primary">
								{{
									$t(
										'Get real value for your items — transparent & fair pricing'
									)
								}}
							</div>
						</div>
					</div>
				</div>
				<div class="why-choose-us__item">
					<div class="why-choose-us__small why-choose-us__small_secondary">
						<div class="why-choose-us__small-content">
							<div class="why-choose-us__subtitle _md">
								{{ $t('Ironclad Security') }}
							</div>
							<div class="why-choose-us__text _text-primary">
								{{
									$t(
										'Every transaction is monitored and protected with advanced anti-fraud systems.'
									)
								}}
							</div>
						</div>
					</div>
					<div class="why-choose-us__large why-choose-us__large_secondary">
						<div class="why-choose-us__box">
							<div class="why-choose-us__large-content">
								<div class="why-choose-us__subtitle _md">
									{{ $t('Instant Deals') }}
								</div>
								<div class="why-choose-us__text _text-primary">
									{{
										$t(
											'Trade your skins in seconds — smooth, direct, and stress-free.'
										)
									}}
								</div>
							</div>
							<div class="why-choose-us__overlay _ibg">
								<img src="@/assets/img/bg/why/03.png" />
							</div>
						</div>

						<div
							class="why-choose-us__bg why-choose-us__bg_secondary _ibg-contain"
						>
							<img src="@/assets/img/bg/why/02.png" />
						</div>
					</div>
				</div>
			</div>
		</div>
	</section>
</template>

<script>
export default {
	name: 'WhyChooseUs',
};
</script>
<style lang="scss" scoped>
@use '@/assets/styles/mixins' as *;
@use '@/assets/styles/media' as *;
@use '@/assets/styles/components/classes' as *;

//========================================================================================================================================================

.why-choose-us {
	@include adaptiveValue('padding-top', 150, 25);
	@include adaptiveValue('padding-bottom', 75, 20);
	&__inner {
	}
	&__title {
		text-align: center;
		&:not(:last-child) {
			@include adaptiveValue('margin-bottom', 25, 15);
		}
	}
	&__line {
		max-width: 710px;
		margin-left: auto;
		margin-right: auto;
		&:not(:last-child) {
			@include adaptiveValue('margin-bottom', 40, 20);
		}
	}
	&__items {
		@media (max-width: $md3) {
			margin: 0 -10px;
		}
	}
	&__item {
		@include adaptiveValue('gap', 20, 10, 1470, 992, 1);
		&:not(:last-child) {
			@include adaptiveValue('margin-bottom', 20, 10, 1470, 992, 1);
		}
		@media (min-width: $md3) {
			display: flex;
		}
		@media (max-width: $md3) {
			&:not(:last-child) {
				margin-bottom: 5px;
			}
		}
	}
	&__large_first,
	&__small {
		@include adaptiveValue('padding-top', 30, 15, 1470, 768, 1);
		@include adaptiveValue('padding-right', 30, 10, 1470, 768, 1);
		@include adaptiveValue('padding-bottom', 30, 15, 1470, 768, 1);
		@include adaptiveValue('padding-left', 30, 10, 1470, 768, 1);
		@include adaptiveValue('min-height', 250, 150, 1470, 768, 1);
		position: relative;
		border-radius: var(--border-radius-primary);
		overflow: hidden;
		display: flex;
		align-items: flex-end;
		@media (max-width: $md3) {
			min-height: 0px;
			&:not(:last-child) {
				margin-bottom: 5px;
			}
		}
		&-content {
			max-width: 370px;
		}
	}
	&__large,
	&__small {
		&-content {
			position: relative;
			z-index: 2;
			max-width: 370px;
		}
	}
	&__large {
		flex: 0 1 67%;
		//background-color: var(--bg-secondary-color);
		background-color: rgba(35, 35, 35, 0.2);
		&_secondary {
			position: relative;
			background-color: transparent;
		}
	}
	&__small {
		flex: 0 1 33%;
		background-color: var(--hint-color);
		&_secondary {
			border: 5px solid var(--hint-color);
			background-color: var(--bg-primary-color);
		}
	}
	&__subtitle {
		font-weight: 900;
	}
	&__text {
	}
	&__box {
		@include adaptiveValue('padding-top', 30, 15, 1470, 768, 1);
		@include adaptiveValue('padding-right', 30, 10, 1470, 768, 1);
		@include adaptiveValue('padding-bottom', 30, 15, 1470, 768, 1);
		@include adaptiveValue('padding-left', 30, 10, 1470, 768, 1);
		@include adaptiveValue('min-height', 250, 150, 1470, 768, 1);
		position: relative;
		border-radius: var(--border-radius-primary);
		overflow: hidden;
		display: flex;
		align-items: flex-end;
		@media (max-width: $md3) {
			min-height: 0px;
			&:not(:last-child) {
				margin-bottom: 5px;
			}
		}
	}
	&__overlay,
	&__bg {
		position: absolute;
		left: 0;
		top: 0;
		width: 100%;
		height: 100%;
		z-index: -1;
		&_secondary {
			width: 55%;
			left: auto;
			top: -8%;
			right: 0px;
			z-index: 1;
		}
	}
	&__overlay {
		width: 125%;
		height: 125%;
		background-color: #676767;
		z-index: -2;
	}
}
</style>
